import type { AppDefinition } from '../types';

/**
 * Logisti — ELM's Bayan platform, marketed in Saudi Arabia as Logisti.
 *
 * The only app with a live connector today. Issues the government electronic
 * waybill (وثيقة النقل) against the Org's own Bayan account, so the Org keeps
 * its own NAQL license and its own compliance record; Hero supplies the
 * platform credentials and the mapping.
 *
 * The Bayan reference data and pure helpers this connector needs live beside
 * this file — plate decomposition, city ids, date formats, phone normalization,
 * good types. See `docs/apps/bayan.md`.
 */
export const LOGISTI_APP: AppDefinition = {
  id: 'logisti',
  nameKey: 'apps.logisti.name',
  descriptionKey: 'apps.logisti.description',
  logo: '/images/apps/logisti-logo.png',
  categories: ['government'],
  status: 'active',
  label: 'new',
  featureFlag: 'bayan_integration',
  subscribes: [
    'order_driver_assigned',
    'order_first_pickup_done',
    'order_delivered',
    'order_canceled',
  ],
};
